































































































import { Component, Vue } from 'vue-property-decorator';
import {
  Button,
  Card,
  Option,
  RadioButton,
  RadioGroup,
  Select
} from 'element-ui';

import { printModeOptions } from '@/constants/printModeOptions';

import fetchShipmentDocuments from '@/graphql/queries/document/List.gql';

import {
  DocumentTypeEnum,
  ShipmentDocumentFields
} from '@/types/graphql/schemaTypes';

@Component({
  apollo: {
    shipmentDocument: {
      query: fetchShipmentDocuments,
      fetchPolicy: 'cache-and-network',
      variables() {
        return {
          shipmentId: this.$route.params.id,
          documentId: this.$route.params.document_id
        };
      },
      update(data) {
        const shipmentDocument = data?.shipmentDocuments?.[0];
        const defaultPrintMode = {
          sea_waybill: 'issue',
          original_bill_of_landing: 'original'
        };
        this.printMode = shipmentDocument
          ? defaultPrintMode[shipmentDocument.documentType]
          : null;
        this.isNotFound = !data?.shipmentDocuments.length;
        return shipmentDocument;
      }
    }
  },
  components: {
    'el-button': Button,
    'el-card': Card,
    'el-option': Option,
    'el-radio-button': RadioButton,
    'el-radio-group': RadioGroup,
    'el-select': Select
  }
})
export default class preview extends Vue {
  shipmentDocument: ShipmentDocumentFields | null = null;
  isNotFound = false;
  displayMode: 'preview' | 'print' = 'preview';
  printMode = null;

  get printModeOptions() {
    if (!this.shipmentDocument) return null;
    return printModeOptions(this.shipmentDocument.documentType);
  }

  getUserToken() {
    let token = '';
    const tokenName = 'X-Auth-Token';
    document.cookie.split(';').forEach((i) => {
      const pair = i.split('=');
      if (pair[0].trim() === tokenName) {
        token = pair[1];
      }
    });
    return token;
  }

  get isDisplayModeRequired() {
    const targetedDocuments = [
      DocumentTypeEnum.sea_waybill,
      DocumentTypeEnum.original_bill_of_landing
    ];

    if (!this.shipmentDocument) return false;
    return targetedDocuments.includes(this.shipmentDocument.documentType);
  }

  get url() {
    const isPreview = this.displayMode === 'preview';

    if (!this.shipmentDocument) {
      return null;
    } else if (this.printMode) {
      // "Sea Waybill" and "Orginal B/L"
      return `${this.shipmentDocument.url}?preview=${isPreview}&mode=${
        this.printMode
      }&token=${this.getUserToken()}&role=operator`;
    } else {
      // Other shipment documents
      return `${
        this.shipmentDocument.url
      }?preview=${isPreview}&token=${this.getUserToken()}&role=operator`;
    }
  }
}
